import { MODAL } from '../types';
import { ModalAction, ModalState } from '../../../config/interface';

export default function setModal(modelState: ModalState): ModalAction {
  return {
    type: MODAL,
    modelState,
  };
}
